import React, { Component } from 'react';
import NavbarOverlayComponent from './NavbarOverlayComponent'
import $ from 'jquery';

export class NavbarComponent extends Component {
         componentDidMount(){
               $(".nav-vertical-slider").hide()
               $(".icon").click(function(){
                  $(this).toggleClass("opens");
                  $( ".nav-vertical-slider" ).slideToggle(1000);
               })

   
         }
      render() {
            return (
             <div style={{width:'100%'}}>
                  <div className="sticky-navbar" style={{zIndex:'9999'}}>
                        <div className="d-flex h-auto ">
                              <div className="hardik">
                                    <h4 className="nav-brand-text">
                                    HARDIK CHUGH
                                    </h4>
                              </div>
                              <div className="hardik ml-auto"  >
                                    <div className="icon">
                                          <span className="one"></span>
                                          <span className="two"></span>
                                          <span className="three"></span>
                                          <span className="four"></span>
                                    </div>
                              </div>
                        </div>
                        <div className="nav-vertical-slider" style={{position:'absolute',zIndex:'999'}} >
                        <NavbarOverlayComponent  />
                  </div>
                  </div>

             </div>
            );
      }
}

export default NavbarComponent;
